// @core/api/endpoints/platform/update_platform_limits.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformLimitsResponse,
  UpdatePlatformLimitsRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update platform resource limits
 * Updates the platform's resource limits. This operation is typically restricted to platform owners and may require subscription changes.
 */
export async function UpdatePlatformLimits(
  platform_id: string,
  data: UpdatePlatformLimitsRequest,
  options?: RequestOptions
): Promise<PlatformLimitsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/limits`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.put<PlatformLimitsResponse>(requestPath, data, requestOptions);
}
